import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCode: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCode"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V21H3V3ZM9.79289 8.29289L11.2071 9.70711L8.91421 12L11.2071 14.2929L9.79289 15.7071L6.08579 12L9.79289 8.29289ZM12.7929 9.70711L15.0858 12L12.7929 14.2929L14.2071 15.7071L17.9142 12L14.2071 8.29289L12.7929 9.70711Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCode;
